// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__19Mwz","label":"CategoryService_label__biiYT","location":"CategoryService_location__20CII"};